module.exports = __webpack_public_path__ + "img/main_mockup_message.d7ff6e9d.png";